import { CondicoesInput, EsquemaCalendarioVacinalQuery } from 'graphql/types.generated'
import _ from 'lodash'
import { DoseItemProps } from 'view/atendimentos/detail/components/vacinacao/DoseItem'
import { ImunobiologicoRowProps } from 'view/atendimentos/detail/components/vacinacao/ImunobiologicoRow'
import { CidadaoAtendimento } from 'view/atendimentos/types/CidadaoAtendimento'

import { CondicoesFormModel } from '../model'
import { getStatusDoseVacinacao } from '../vacinacaoUtils'

export const convertCondicoesToInput = (form: CondicoesFormModel): CondicoesInput =>
  form && {
    isGestante: form.gestante,
    isPuerpera: form.puerpera,
    isViajante: form.viajante,
    isComunicanteHanseniase: form.comunicanteHanseniase,
  }

export const convertEsquemaCalendarioVacinalQueryToProps = (
  data: EsquemaCalendarioVacinalQuery,
  cidadao: CidadaoAtendimento,
  dataAtendimento: Instant
): ImunobiologicoRowProps[] => {
  return _.chain(data.esquemaCalendarioVacinal)
    .groupBy('imunobiologico.id')
    .map((value, key) => {
      const doseProp = value.map<DoseItemProps>((doseItem) => ({
        model: {
          calendarioId: doseItem.id,
          doseId: doseItem.dose.id,
          nome: doseItem.dose.nomeApresentacaoDose,
          faixaEtaria: doseItem.idadeRecomendada,
          status: getStatusDoseVacinacao(
            cidadao.dataNascimento,
            dataAtendimento,
            doseItem.faixaEtaria.diasInicio,
            doseItem.faixaEtaria.diasFim
          ),
          mostrarNoCalendarioDoGrupo: doseItem.mostrarNoCalendarioDoGrupo,
        },
      }))
      return {
        model: {
          imunobiologicoId: key,
          nome: value[0].descricaoImunobiologico,
          doses: doseProp,
        },
      } as ImunobiologicoRowProps
    })
    .value()
}
